import React, { useEffect } from "react";
import { Controller, Control, FieldErrors, UseFormSetValue } from "react-hook-form";
import { Form, Spinner } from "react-bootstrap";
import useGetAllRoomType from "../../../../services/room-type/hooks/useGetAllRoomType";

interface RoomSelectComponentProps {
    control: Control<any>;
    errors: FieldErrors<{
        filter: {
            property_id: string;
            start_date: string;
            end_date: string;
            room_type_id?: string;
        };
    }>;
    setValue: UseFormSetValue<any>;
}

const RoomSelectComponent: React.FC<RoomSelectComponentProps> = ({ control, errors, setValue }) => {
    const { data: roomTypes, isFetching, error } = useGetAllRoomType({ all: true });

    // Set default value sebagai string (id,id,id) saat pertama kali data tersedia
    useEffect(() => {
        if (roomTypes?.data) {
            const allRoomIds = roomTypes.data.map((room: any) => room.id).join(","); // Tetap string
            setValue("filter.room_type_id", allRoomIds, { shouldValidate: true });
        }
    }, [roomTypes, setValue]);

    return (
        <div>
            <Form.Label className="me-2">Select Rooms:</Form.Label>

            {isFetching ? (
                <div className="d-flex align-items-center">
                    <Spinner animation="border" size="sm" className="me-2" />
                    <span>Loading rooms...</span>
                </div>
            ) : error ? (
                <div className="text-danger">Failed to load rooms</div>
            ) : (
                <Controller
                    name="filter.room_type_id"
                    control={control}
                    rules={{
                        validate: (value) => (value?.length > 0 ? true : "Select at least one room"),
                    }}
                    render={({ field }) => {
                        // Konversi field.value ke array string
                        const selectedRoomIds = field.value ? field.value.split(",") : [];

                        return (
                            <div>
                                {roomTypes?.data.map((room: any) => {
                                    const roomId = room.id; // Biarkan tetap string

                                    return (
                                        <Form.Check
                                            key={roomId}
                                            type="checkbox"
                                            id={`room-${roomId}`}
                                            label={room.name}
                                            checked={selectedRoomIds.includes(roomId)}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                let updatedRoomIds = checked
                                                    ? [...selectedRoomIds, roomId] // Tambah room
                                                    : selectedRoomIds.filter((id: string) => id !== roomId); // Hapus room

                                                // Konversi ke string sebelum menyimpan
                                                field.onChange(updatedRoomIds.join(","));
                                            }}
                                        />
                                    );
                                })}
                                {errors.filter?.room_type_id && (
                                    <div className="text-danger mt-1">
                                        {errors.filter.room_type_id.message as string}
                                    </div>
                                )}
                            </div>
                        );
                    }}
                />
            )}
        </div>
    );
};

export default RoomSelectComponent;